import { Icon, ImageFit, IRenderFunction, mergeStyleSets } from "@fluentui/react";
import React, { InputHTMLAttributes, RefAttributes } from "react";

const SearchIcon = ({ size = "20px", iconName = "search.png" }: { size?: string; iconName?: string }) => {
  return (
    <Icon
      style={{
        display: "flex",
        alignItems: "center",
        animation: "none !important",
        transition: "none !important",
      }}
      imageProps={{
        src: `/assets/${iconName}`,
        imageFit: ImageFit.contain,
        width: size,
        height: size,
        styles: {
          root: {
            animation: "none !important",
            transition: "none !important",
          },
        },
        style: {
          animation: "none !important",
          transition: "none !important",
        },
      }}
    />
  );
};

const onRenderInputWrapper: (variant: "compact" | "default") => IRenderFunction<
  InputHTMLAttributes<HTMLInputElement> & RefAttributes<HTMLInputElement>
  // eslint-disable-next-line react/display-name
> = (variant) => (props, defaultRender) => {
  /* eslint-disable react/prop-types */
  return (
    <>
      {variant === "compact" && <SearchIcon size="14px" iconName="search.svg" />}
      {defaultRender(props)}
      {variant === "default" && <SearchIcon />}
    </>
  );
  /* eslint-enable react/prop-types */
};

export const useSearchBar = (variant: "default" | "compact" = "default") => {
  const classNames = mergeStyleSets({
    container: {
      width: "100%",
      padding: variant === "default" ? "8px 16px !important" : "8px 0px !important",
      flexGrow: 1,
      animation: "none !important",
      transition: "none !important",
    },
    searchBar: {
      border: variant === "default" ? "none !important" : "1px solid #d8d8d8 !important",
      boxShadow: "none !important",
      fontSize: variant === "default" ? "16px !important" : "14px !important",
      borderRadius: variant === "default" ? "0px !important" : "8px !important",
      padding: variant === "default" ? "0px 2px !important" : "0px 2px 0px 4px !important",
      width: "100% !important",
      animation: "none !important",
      transition: "none !important",
    },
    formField: {
      position: "relative",
      borderBottom: variant === "default" ? "2px solid #d8d8d8" : "none",
      display: "inline-block",
      width: "100%",
      animation: "none !important",
      transition: "none !important",
    },
  });
  return {
    classNames,
    onRenderInputWrapper,
  };
};
